import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import BasicPopover from "../../BasicPopover";
import { Button } from "antd";
import MapFilters from "../container/MapFilters";
import * as Icon from "../smartiscity/Icons";
import { useTranslation } from "react-i18next";

const SearchArea = ({
  sensorTypes,
  showPopover,
  refreshComponent,
  categoryId,
  selectedCategory,
  refreshMap,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const handleSensorTypeClick = useCallback(
    (sensorType) => {
      showPopover.set(false);
      history.push(`${pathname}?typeId=${sensorType.id}`);
      refreshComponent();
    },
    [history, pathname, refreshComponent],
  );

  return (
    <SearchAreaContainer role="search">
      <SearchWrapper>
        <InputIcon>
          <img src={Icon.search} width="20px" alt="Search" />
        </InputIcon>
        <SearchInput placeholder="Αναζήτηση" />
      </SearchWrapper>
      <DropdownContent>
        <BasicPopover
          buttonTitle={t("settings.subsystem")}
          showPopover={showPopover.get}
          setShowPopover={showPopover.set}
        >
          <div
            style={{
              maxHeight: "300px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {sensorTypes.SensorTypesData?.map((sensorType) => (
              <SensorItem
                key={sensorType.id}
                onClick={() => handleSensorTypeClick(sensorType)}
              >
                {sensorType.title}
              </SensorItem>
            ))}
          </div>
        </BasicPopover>
        <BasicPopover buttonTitle={t("settings.variable")}>
          <div
            style={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <p style={{ color: "gray" }}>{t("Επιλέξτε μεταβλήτες")}</p>
            <MapFilters
              categoryId={categoryId}
              selectedCategory={selectedCategory}
              isAmea={categoryId === "122"}
              refreshMap={refreshMap}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                justifyContent: "flex-end",
              }}
            >
              <Button>Ακύρωση Φίλτρων</Button>
            </div>
          </div>
        </BasicPopover>
      </DropdownContent>
    </SearchAreaContainer>
  );
};

export default SearchArea;

const SearchAreaContainer = styled.div`
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-items: center;
`;

const SearchWrapper = styled.div`
  border: 1px solid #00000029;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 2px;
`;

const InputIcon = styled.div`
  width: 20px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  height: 50px;
  border: none;
  padding-block: 0 !important;
  width: 260px;
  outline: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5%;
  color: #373b40;
  background-color: transparent;
  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
    opacity: 1; /* Firefox */
  }
`;

const DropdownContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
`;

const SensorItem = styled.div`
  cursor: pointer;
  padding: 8px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;
